import { getBaseUrl, Microservice } from "../constant/baseUrl";
import axios from "axios";
import { getApiResponseErrorMsg } from "@funded-here-interface/common/src/Utils/apiHelper";

type GetDocumentRequest = {
  token: string;
  path: string;
};

const getDocument = async ({ token, path }: GetDocumentRequest) => {
  try {
    const normalizedPath = path.replace(/\\/g, "//");
    const response = await axios.get(
      `${getBaseUrl(Microservice.TRADE_DIRECTORY)}/trade-directory/upload/document`,
      {
        params: {
          path: normalizedPath,
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        responseType: "blob",
        withCredentials: true,
      },
    );

    return response.data;
  } catch (e) {
    const message = getApiResponseErrorMsg(e);

    throw new Error(message);
  }
};

export default getDocument;
